import {addDoc, collection, Timestamp} from 'firebase/firestore';
import {firestore, getCollectionPath} from '../config/Firebase';
import Debug from './Debug';

export default class Activity {
    static log(kioskData, entityType, entityId, action, fromUser, metadata) {
        const hasRequiredData = this.validProperties(kioskData) && entityType && entityId && action;
        if (hasRequiredData) {
            const client   = kioskData && kioskData.client   ? kioskData.client      : undefined;
            const instance = kioskData && kioskData.instance ? kioskData.instance.id : undefined;
            const catalog  = kioskData && kioskData.catalog  ? kioskData.catalog.id  : undefined;
            const store    = kioskData && kioskData.store    ? kioskData.store.id    : undefined;
            const session  = kioskData && kioskData.session  ? kioskData.session.id  : undefined;
            const data = {
                client: client,
                instance: instance,
                catalog: catalog,
                store: store,
                session: session,
                entity_type: entityType,
                entity_id: entityId || null,
                action: action,
                from_user: fromUser,
                metadata: metadata ? this.sanitizeData(metadata) : null,
                timestamp: Timestamp.now()
            };
            const _path = getCollectionPath(client, 'activity');
            const _collection = collection(firestore, _path);
            return addDoc(_collection, data)
                .catch((error) => {
                    Debug.printToLog('error', error);
                });
        } else {
            Debug.printToLog('error', 'Activity.log() is missing required data.');
            Debug.printToLog('error', {kioskData, entityType, entityId, action, fromUser, metadata});
            return Promise.resolve();
        }
    };

    static validProperties = (metadata) => {
        const client   = metadata && metadata.client   ? metadata.client      : undefined;
        const instance = metadata && metadata.instance ? metadata.instance.id : undefined;
        const catalog  = metadata && metadata.catalog  ? metadata.catalog.id  : undefined;
        const store    = metadata && metadata.store    ? metadata.store.id    : undefined;
        const session  = metadata && metadata.session  ? metadata.session.id  : undefined;
        return !!client && !!instance && !!catalog && !!store && !!session;
    };

    static sanitizeData = (data) => {
        if (typeof data === 'object' && data !== null) {
            Object.keys(data).forEach((key) => {
                data[key] = this.sanitizeData(data[key]);
            });
        } else if (Array.isArray(data)) {
            data = data.map((item) => this.sanitizeData(item));
        } else if (data === undefined) {
            data = null;
        } else {
            data = data;
        }
        return data;
    };
}